import React, { useContext, useState } from 'react';
import { View, Pressable, Text } from 'react-native';
import styled from 'styled-components/native';

import { Link } from 'app/src/utils/routing';
import AuthContext from 'app/src/contexts/AuthContext';
import { buttonBackground } from 'app/src/styles/colors';
import Modal from 'app/src/elements/Modal';
import Settings from 'app/src/components/Settings';

import Account from './index';

const Dropdown = styled(View)`
  z-index: 9999;
  position: absolute;
  width: 300px;
  right: 10px;
  top: 80px;
  background-color: white;
  border: 1px solid ${buttonBackground};
  border-radius: 6px;
  padding: 12px;

  @media (max-width: 768px) {
    top: 180px;
  }
`;

const LinkContainer = styled(View)`
  display: flex;
`;

const AccountMenu = ({ hide }) => {
  const { clearCredentials, user } = useContext(AuthContext);
  const [showEditAccountModal, setShowEditAccountModal] = useState();
  const [showSettingsModal, setShowSettingsModal] = useState();

  return (
    <Dropdown>
      <LinkContainer id="account-menu">
        <Pressable onPress={() => setShowEditAccountModal(true)}>
          <Text>Update Account/Password</Text>
        </Pressable>
        <br />
        {'Admin' == user?.role && (
          <>
            <Pressable onPress={() => setShowSettingsModal(true)}>
              <Text>Seller Settings</Text>
            </Pressable>
            <br />
          </>
        )}
        <Pressable
          onPress={() => clearCredentials()}
        >
          <Text>
            Logout
          </Text>
        </Pressable>
      </LinkContainer>
      {showSettingsModal &&
        <Modal
          showModal={showSettingsModal}
          setShowModal={setShowSettingsModal}
          modalType="Seller Settings"
        >
          <Settings setShowModal={setShowSettingsModal} />
        </Modal>
      }
      {showEditAccountModal &&
        <Modal
          showModal={showEditAccountModal}
          setShowModal={setShowEditAccountModal}
          modalType={'Edit Account'}
        >
          <Account
            setShowModal={setShowEditAccountModal}
          />
        </Modal>
      }
    </Dropdown>
  )
};

export default AccountMenu;
